import { useEffect, type ReactNode } from 'react';
import { ConfigProvider } from 'antd';
import trTR from 'antd/locale/tr_TR';
import { antdTheme, demoTheme, getThemeCSSVariables, fontFamilySans } from '../theme';

interface ThemeProviderProps {
  children: ReactNode;
}

const GLOBAL_STYLE_ID = 'raporgor-theme-globals';

export function ThemeProvider({ children }: ThemeProviderProps) {
  useEffect(() => {
    let el = document.getElementById(GLOBAL_STYLE_ID) as HTMLStyleElement | null;
    if (!el) {
      el = document.createElement('style');
      el.id = GLOBAL_STYLE_ID;
      document.head.appendChild(el);
    }
    el.textContent = `
      :root { ${getThemeCSSVariables(demoTheme)} }

      body, #root {
        margin: 0;
        padding: 0;
        height: 100%;
        font-family: ${fontFamilySans};
        font-size: 13px;
        line-height: 1.45;
        font-feature-settings: 'tnum', 'ss01';
        font-variant-numeric: tabular-nums;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        color: var(--color-text-primary);
        background: var(--color-page-bg);
      }

      /* Kurumsal finans aesthetic — nümerik kolonlar için tablobased numerals */
      .tabular, .num { font-variant-numeric: tabular-nums; font-feature-settings: 'tnum'; }

      /* Scrollbar polish */
      ::-webkit-scrollbar { width: 10px; height: 10px; }
      ::-webkit-scrollbar-thumb { background: #cbd5e1; border-radius: 0; border: 2px solid transparent; background-clip: padding-box; }
      ::-webkit-scrollbar-track { background: transparent; }
    `;
  }, []);

  return (
    <ConfigProvider locale={trTR} theme={antdTheme}>
      {children}
    </ConfigProvider>
  );
}
